import type { CreateSellListingFormPayload } from "@/lib/listing/createSellListing";
import type { SellListingFormData } from "@/lib/listing/sellListingFormTypes";
import type {
  BulkListingCommonState,
  BulkListingItemDraft,
} from "@/lib/listing/bulkListingTypes";
import type { ItemCategory } from "@/lib/types";

/** Maps single-mode sell form state to the create API form payload. */
export function formPayloadFromSellForm(
  formData: SellListingFormData,
): CreateSellListingFormPayload {
  return {
    title: formData.title,
    description: formData.description,
    defects: formData.defects,
    price: formData.price,
    category: formData.category,
    subcategory: formData.subcategory,
    location: formData.location,
    quantity: formData.quantity,
    brand: formData.brand,
    size: formData.size,
    model: formData.model,
    familySpecs: formData.familySpecs,
  };
}

/**
 * Maps one bulk draft row + shared common fields to the create API form payload.
 * Caller must ensure category/subcategory are set before submit.
 */
export function formPayloadFromBulkDraft(
  draft: BulkListingItemDraft,
  bulkCommon: BulkListingCommonState,
): CreateSellListingFormPayload {
  return {
    title: draft.title,
    description: draft.description,
    defects: draft.defects,
    price: draft.price,
    category: draft.category as ItemCategory,
    subcategory: draft.subcategory,
    location: bulkCommon.location,
    quantity: draft.quantity,
    brand: draft.brand,
    size: draft.size,
    model: draft.model,
    familySpecs: draft.familySpecs,
  };
}
